import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
interface DeeplinkState {
  resolved: boolean;

  initialRoute: {
    name: string;
    params?: Record<string, any>;
  } | null;

  pendingUrls: string[];

  setInitialRoute: (r: DeeplinkState["initialRoute"]) => void;
  setResolved: (v: boolean) => void;

  pushUrl: (url: string) => void;
  consumeUrl: () => string | null;
}

export const useDeeplinkStore = create<DeeplinkState>()(
  subscribeWithSelector((set, get) => ({
    resolved: false,
    initialRoute: null,
    pendingUrls: [],

    setInitialRoute: (initialRoute) => set({ initialRoute }),
    setResolved: (resolved) => set({ resolved }),

    pushUrl: (url) =>
      set((s) => ({
        pendingUrls: [...s.pendingUrls, url],
        resolved: false,
      })),

    consumeUrl: () => {
      const urls = get().pendingUrls;
      if (!urls.length) return null;

      const [first, ...rest] = urls;
      set({ pendingUrls: rest });
      return first;
    },
  }))
);